import { render, staticRenderFns } from "./epb-animated-background.component.vue?vue&type=template&id=65b95b49&scoped=true"
import script from "./epb-animated-background.component.vue?vue&type=script&lang=ts"
export * from "./epb-animated-background.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-animated-background.component.vue?vue&type=style&index=0&id=65b95b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b95b49",
  null
  
)

export default component.exports